import { render } from "./frCookieBanner.vue?vue&type=template&id=18f61b01"
import script from "./frCookieBanner.vue?vue&type=script&lang=js"
export * from "./frCookieBanner.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__